import { render, staticRenderFns } from "./Connect.vue?vue&type=template&id=1887a84b&scoped=true&"
import script from "./Connect.vue?vue&type=script&lang=js&"
export * from "./Connect.vue?vue&type=script&lang=js&"
import style0 from "./Connect.vue?vue&type=style&index=0&id=1887a84b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1887a84b",
  null
  
)

export default component.exports